<button type="button" [disabled]="isDisabled" class="btn btn-outline-dark btn-sm" [id]="'remove' + theId" (click)="onClick()">
  <i class="fas fa-minus-circle"></i>
  &nbsp;{{ 'campaign.ad.remove' | translate }}
</button>
